import httpManager from "@/app/shared/utils/httpManager";

/**
 * Consulta si un alias "Enviar como" ha sido utilizado en hilos o correos.
 *
 * @param {number} channelCustomerId - ID del identificador de canal.
 * @param {number} id - ID del alias.
 * @returns {Promise<Object>} Datos de uso del alias.
 */
export default async function (channelCustomerId, id) {
  const response = await httpManager.get(
    `/channels/channel-customer/${channelCustomerId}/send-as-aliases/${id}/usage/`
  );
  return response?.data;
}
